import Axios from '@/api/http'

export function getrelationuser (date) {
  return Axios({
    method: 'post',
    url: '/api/getrelationuser',
    data: date
  })
}

export function getapprovalcontent (date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalcontent',
    data: date
  })
}

export function getfielddatalist (date) {
  return Axios({
    method: 'post',
    url: '/openapi/getfielddatalist',
    data: date
  })
}
export function getuserccapprovallist (date) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserccapprovallist',
    data: date
  })
}
